export default {"src":"/_next/static/media/icon-hot.c70610f2.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};